import axios from "axios";
import { ApiActiveRace, ApiRace, formatdateYYYYMMDD } from "../types";
import { authHeader, getToken, hasAuth } from "./auth.header";

/* -------------------------------------------------------------------------------- *\
|                               findapiserverurl
\* -------------------------------------------------------------------------------- */
export const findapiserverurl = (): string =>
{
	if (process.env.REACT_APP__API_URL) return process.env.REACT_APP__API_URL;

	return 'https://spectator.mclloyd.com';
}
/* -------------------------------------------------------------------------------- *\
|                               findwsserverurl
\* -------------------------------------------------------------------------------- */
export const findwsserverurl = (): string =>
{
	if (process.env.REACT_APP__WS_URL) return process.env.REACT_APP__WS_URL;

	return 'https://spectator.mclloyd.com/ws';
}
/* -------------------------------------------------------------------------------- *\
|                               get_meeting_list
\* -------------------------------------------------------------------------------- */
export const get_meeting_list = async (date: string) : Promise<ApiRace[]> =>
{
	if (!hasAuth())
	{
		return Promise.resolve([]);
	}
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + `/api/races/${date}`, { headers: authHeader() }))
		.then(response => 
		{
			var races = response.data as ApiRace[];
			for(var race of races)
			{
				const date: Date = new Date(race.date);
				const ta: number = date.getHours() * 60 + date.getMinutes();
				race.start = ta;
				race.yyyymmdd = formatdateYYYYMMDD(date);
				race.hours = date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false });
			}
			return races;
		});
}
/* -------------------------------------------------------------------------------- *\
|                               get_race
\* -------------------------------------------------------------------------------- */
export const get_race = async (date: string, track: string, race: number) : Promise<ApiRace> =>
{
	if (!hasAuth())
	{
		return Promise.resolve(new ApiRace());
	}
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + `/api/race/${date}/${track}/${race}`, { headers: authHeader() }))
		.then(response => 
		{
			var race = response.data as ApiRace;
			const date: Date = new Date(race.date);
			const ta: number = date.getHours() * 60 + date.getMinutes();
			race.start = ta;
			return race;
		});
}
/* -------------------------------------------------------------------------------- *\
|                               get_activeraces
\* -------------------------------------------------------------------------------- */
export const get_activeraces = async () : Promise<ApiActiveRace[]> =>
{
	if (!hasAuth())
	{
		return Promise.resolve([]);
	}
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + '/api/activeraces', { headers: authHeader() }))
		.then(response => 
		{
			var races = response.data as ApiActiveRace[];
			return races;
		});
}
/* -------------------------------------------------------------------------------- *\
|                               get_config
\* -------------------------------------------------------------------------------- */
export const get_config = async () : Promise<any> =>
{
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + '/api/config', { headers: authHeader() }))
		.then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               put_config
\* -------------------------------------------------------------------------------- */
export const put_config = async (data: any) : Promise<any> =>
{
	return Promise.resolve()
		.then(() => axios.put(findapiserverurl() + '/api/config', data, { headers: authHeader() }))
		.then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               get_hasarchives
\* -------------------------------------------------------------------------------- */
export const get_hasarchives = async () : Promise<boolean> =>
{
	if (!hasAuth())
	{
		return Promise.resolve(false);
	}
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + '/api/hasarchives/' + getToken()))
		.then(response => response.data as boolean);
}
